/**
 * Voice Chat Factory
 * 
 * This file provides a factory function for creating voice chat instances
 * with different configurations and tool sets.
 */
import type { VoiceChatBase, VoiceChatOptions } from './VoiceChatBase';

/**
 * Create a voice chat instance of the specified type
 * 
 * @param ChatClass The voice chat class to instantiate
 * @param options Configuration options for the voice chat
 * @returns An instance of the specified voice chat class
 */
export function createVoiceChat<T extends VoiceChatBase>(
  ChatClass: new (options: VoiceChatOptions) => T,
  options?: Partial<VoiceChatOptions>
): T {
  // Create options object with any provided options
  const chatOptions: VoiceChatOptions = {
    ...options
  };
  
  // Create and return voice chat instance
  return new ChatClass(chatOptions);
} 